import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'

/**
 * This is also used on the team integrations page, so the naming convention will be left as is,
 * since its usage there is not Golden Signal specific.
 */
export interface StatusCheckHeader {
  key: string
  value: string
  label?: string
}

export interface Predicate {
  type?: PredicateType
  jqQuery?: string
  jpQuery?: string
  comparator?: string
  rValue?: any
}

export enum PredicateType {
  String = 'String',
  Number = 'Number',
  Boolean = 'Boolean'
}

export interface ResponseBodyEvaluation {
  op?: 'AND' | 'OR'
  predicates?: Predicate[]
}

export interface GoldenSignalEvaluationConfiguration {
  healthyStatusCode: string
  requestTimeout: number
  responseBodyEvaluation?: ResponseBodyEvaluation
}
export interface ServiceGoldenSignal {
  id?: string
  integration: TeamExternalIntegration
  name: string
  evaluationConfiguration: GoldenSignalEvaluationConfiguration
  isContinuous: boolean
  description?: string
}

export enum authenticationStatus {
  Authenticated = 'AUTHENTICATED',
  UnAuthenticated = 'UNAUTHENTICATED',
  Untested = 'UNTESTED'
}

export interface TeamExternalIntegration {
  type: IntegrationType
  name: string
  id?: string
  url?: string
  headers?: StatusCheckHeader[]
  isPrivateNetworkIntegration?: boolean
  isConfigured?: boolean
  authUrl?: string
  lastAuthenticationStatus?: authenticationStatus
  canBeUsedAsStatusCheck?: boolean
  sortIndex?: number
  isOther?: boolean
}
